import { httpService } from "@productfinder/shared/http-service";
import { helper } from "@productfinder/shared/helper";

let initialStateScrollY = false;

export const actions = {
    setUseHash: ({ commit }, useHash = true) => {
        commit('setUseHash', useHash);
    },
    setApi: ({ commit }, payload) => {
        if (!payload) {
            payload = {url: window.PRODUCTFINDER_API};
        }
        commit('setApi', payload);
    },
    setConfig: ({ commit }, config) => {
        if (!config) {
            config = window.PRODUCTFINDER_CONFIG;
        }
        if (config) {
            commit('setConfig', config)
        } else {
            new Error("Could not load product finder configuration");
        }
    },
    setLocalization: ({ commit }) => {
        if (window.jsI18N.productfinder) {
            commit('setLocalization', window.jsI18N.productfinder);
        }
    },
    loadInitialData: ({ commit, state, getters }, initialData = null) => {
        if (initialData === null) {
            const initialState = state.useHash ? helper.getInitialStateFromHash(getters.filterByName) : null;
            // console.log('initialState', initialState);
            if (initialState !== null && (initialState.filterConfig !== null || initialState.offset !== 0)) {
                if (initialState.filterConfig !== null) {
                    commit('replaceFilterState', initialState.filterConfig);
                }
                commit('setFreeze', true);

                httpService.fetchResults(state, initialState.offset, true)
                    .then(data => {
                        commit('setResults', data.entities);
                        commit('setAvailableFilters', data.available);
                        commit('setTotal', data.total);
                        if (initialState.scrollY && state.useHash) {
                            history.replaceState({}, '', window.location.pathname + '#' + encodeURI(helper.generateHash(getters.selectedFilters)) + '#' + initialState.offset);
                            initialStateScrollY = initialState.scrollY;
                        }
                        commit('setFreeze', false);
                    });
                return;
            }
        }

        if (!initialData) {
            initialData = window.PRODUCTFINDER_INITIAL;
        }
        if (initialData) {
            commit('setFreeze', false);
            commit('setInitData', initialData);
            commit('setTotal', initialData.total)
        } else {
            commit('setFreeze', false);
            new Error("Could not load product finder initial data");
        }
        commit('replaceFilterState', {});
    },
    allResultImagesLoaded: () => {
        // console.log('handling allResultImagesLoaded', initialStateScrollY);
        // Der hört jetzt nur darauf, dass alle Produktfinder-Bilder geladen sind. Genaugenommen müsste er auf alle
        // Bilder auf der Seite warten, wenn man browser-back mit deaktiviertem Browser-Cache aufruft.
        // Bei echter Annavigation ist das kein Problem; vmtl. weil beim Browser-Back der Browser selbst eine Scroll-
        // Position wiederherstellt. Naja, wenn man Cache an hat ist das vmtl. eh kein Thema *daumen drück*
        if (initialStateScrollY) {
            const scrollY = initialStateScrollY;
            setTimeout(() => {
                window.scrollTo(0, scrollY);
            }, 100);
        }
        initialStateScrollY = false;
    },
    setFilterState: ({ commit, state, getters }, { filterName, value }) => {
        if (!state.freeze) {
            commit('setFreeze', true);
            commit('setFilterStateValue', { name: filterName, value: value });

            if (state.useHash) {
                window.location.hash = encodeURI(helper.generateHash(getters.selectedFilters));
            }

            // Tracking "interaction" with product finder
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'Interaktion', {
                    'event_category': 'Produkt-Finder',
                    'event_label': 'add ' + filterName + ': ' + value
                });
            }

            httpService.fetchResults(state)
                .then(data => {
                    commit('setFreeze', false);
                    commit('setResults', data.entities);
                    commit('setAvailableFilters', data.available);
                    commit('setTotal', data.total);
                });
        }
    },
    removeFilterState: ({ commit, state, getters }, { filterName, value }) => {
        if (!state.freeze) {
            commit('setFreeze', true);

            commit('removeFilterState', { filterName: filterName, value: value });
            if (state.useHash) {
                window.location.hash = encodeURI(helper.generateHash(getters.selectedFilters));
            }

            // Tracking "interaction" with product finder
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'Interaktion', {
                    'event_category': 'Produkt-Finder',
                    'event_label': 'remove ' + filterName + ': ' + value
                });
            }

            httpService.fetchResults(state)
                .then(data => {
                    commit('setFreeze', false);
                    commit('setResults', data.entities);
                    commit('setAvailableFilters', data.available);
                    commit('setTotal', data.total);
                })
        }
    },
    loadMoreResults: ({ commit, state, getters }) => {
        if (!state.freeze) {

            commit('setFreeze', true);
            if (state.useHash) {
                history.replaceState({}, '', window.location.pathname + '#' + encodeURI(helper.generateHash(getters.selectedFilters)) + '#' + state.results.length);
            }
            httpService.fetchResults(state, state.results.length)
                .then(data => {
                    commit('setFreeze', false);
                    commit('appendResults', data.entities);
                });
        }
    },
    setBackground: ({ commit }, { background }) => {
        commit('setBackground', background);
    }
};
